import { itpErrorsDictionary } from "./itp/itpErrorsDictionary"

const masterDictionary = {
    'itp': itpErrorsDictionary
}

export { masterDictionary }
